/**
 * Semantic search API client — Cmd+K modal hits this.
 */
import { api } from './api';

export type SourceKind =
  | 'email_signal' | 'deal' | 'action' | 'memory' | 'contract'
  | 'note' | 'transcript' | 'client' | 'invoice' | 'document'
  | 'sales_activity' | 'meeting_signal' | 'meeting_transcript' | 'meeting_promise';

export interface SearchResult {
  id: string;
  source_kind: SourceKind;
  source_id: string;
  content: string;
  metadata: Record<string, unknown>;
  similarity: number;
  created_at: string;
}

export function semanticSearch(
  q: string,
  opts?: { kinds?: SourceKind[]; limit?: number; minSimilarity?: number; since?: string },
): Promise<{ query: string; results: SearchResult[]; count: number }> {
  return api('/v1/search/semantic', {
    method: 'POST',
    body: JSON.stringify({ q, ...opts }),
  });
}

export interface EmbeddingStats {
  total: number;
  embedded: number;
  pending: number;
  by_kind: Record<string, { total: number; embedded: number; pending: number }>;
}
export function getEmbeddingStats(): Promise<EmbeddingStats> {
  return api('/v1/search/stats');
}

export function backfillEmbeddings(): Promise<{ queued: number; skipped: number; swept_now: number }> {
  return api('/v1/search/backfill', { method: 'POST', body: '{}' });
}
